import { Text } from "../../Components/atoms/Typography/Text/Text";
import { ActionButton } from "../../Components/molecules/ActionButton/ActionButton";
import dayjs from "dayjs";

export const getColumns = (t, clickHandler) => {

    let columndata = [
        {
          fieldtext: "Specialty ID",
          field: "specId",
          width: "140",
          textAlign: "Left",
        },
        {
          fieldtext: "Specialty",
          field: "description",
          width: "180",
          textAlign: "Left",
        },

        {
          fieldtext: "Created date",
          field: "createdOn",
          width: "180",
          textAlign: "Left",
          template: (props) => {
            const dateOnly = props.createdOn
              ? new Date(props.createdOn).toLocaleDateString("en-GB", { timeZone: "Asia/Colombo" })
              : "-";
            return <span>{dateOnly}</span>;
  },
        },

        {
          fieldtext: "Created by",
          field: "email",
          width: "180",
          textAlign: "Left",
        },

        {
          fieldtext: "Actions",
          field: "actions",
          width: "88px",
          textAlign: "Left",
          allowSorting: false,
          headerTextAlign: "Left",
          key: 6,
          template: (props) => {
            return (
              <ActionButton
                clickHandler={(e) => clickHandler(e, props)}
                Options={[

                  {
                    id: 1,
                    element: (
                      <Text
                        text={t("View")}
                        color={"blue.primaryBlue"}
                      />
                    ),
                  },

                  {
                    id: 2,
                    element: (
                      <Text
                        text={t("Edit")}
                        color={"blue.primaryBlue"}
                      />
                    ),
                  },
                  {
                    id: 5,
                    element: (
                      <Text
                        text={t("Delete")}
                        color={"blue.primaryBlue"}
                      />
                    ),
                  },
                ]}
              />
            );
          },
        },
      ];
      return columndata;
    };